import { testi, units as unitsData } from "./live";
import { lowestNightly } from "@/lib/pricing";
import { SUPPORTED_LANGS } from "@/i18n";

export const SITE_ORIGIN = "https://postumia-place.pages.dev";

export const IMG = {
  hero: `/images/site/${testi.images.hero.file}`,
  patio: `/images/site/${testi.images.patio.file}`,
};

export const IMG_ALT = {
  hero: testi.images.hero.alt,
  patio: testi.images.patio.alt,
};

function computeRating(reviews) {
  const visible = reviews.filter((r) => !r.hidden);
  if (visible.length === 0) return { rating: "0.0", reviewsCount: 0 };
  const avg = visible.reduce((sum, r) => sum + r.rating, 0) / visible.length;
  return { rating: avg.toFixed(2), reviewsCount: visible.length };
}

// Units in draft ("Bozza" in the admin panel) are not shown anywhere on the site.
export const UNITS = unitsData.filter((u) => !u.availability?.draft).map((u) => {
  const { rating, reviewsCount } = computeRating(u.reviews);
  const images = u.images.map((img) => `/images/camere/${u.slug}/${img.file}`);
  // Built from SUPPORTED_LANGS so a newly added language can't be missed
  // (a hand-written list once omitted "es" and crashed /es/ unit pages).
  const imageLabels = Object.fromEntries(
    SUPPORTED_LANGS.map((l) => [l, u.images.map((img) => img.alt[l] || img.alt.it)]),
  );
  const reviews = u.reviews.filter((r) => !r.hidden);
  // "Non disponibile" senza intervalli = fuori mercato del tutto. Con
  // intervalli inseriti, blocca solo quelle date nel calendario e resta
  // prenotabile per il resto (occupato da un ospite, non "in pausa").
  const ranges = u.availability?.blockedRanges ?? [];
  const availabilityStatus = u.availability?.comingSoon
    ? "comingSoon"
    : (u.availability?.unavailable && ranges.length === 0)
      ? "unavailable"
      : null;
  const bookable = availabilityStatus === null;
  const blockedDateRanges = u.availability?.unavailable
    ? ranges.map((r) => ({ from: new Date(`${r.from}T00:00:00`), to: new Date(`${r.to}T00:00:00`) }))
    : [];
  // "from X per night" is shown only when the admin ticks the box: the figure is public.
  const fromPrice = u.pricing?.showFromPrice ? lowestNightly(u.pricing) : null;
  return { ...u, rating, reviewsCount, cover: images[0], images, imageLabels, reviews, availabilityStatus, bookable, blockedDateRanges, fromPrice };
});
